import { Value } from '@philips-internal/oswald-ui-core';

export class HealthHistoryListContext {
  static state: Record<string, Value>;
  static currentTab = '';
  static isAllowEdit = true;

  static set(data: Record<string, Value>): void {
    this.state = data;
  }

  static clean(): void {
    this.currentTab = '';
    this.state = {};
  }

  static get(): Record<string, Value> {
    return this.state;
  }
}
